<template>
  <div>
    <NBar title="启动页消息通知" :top="true"/>
    <div class="top-div">
      <span class="text">请设置消息通知的场地</span>
      <nut-button small @click="goBatchSelect(4)">批量设置</nut-button>
    </div>
    <nut-infiniteloading @loadmore="onInfinite" :is-show-mod="true" :has-more="isHasMore" :is-loading="isLoading"
                         :threshold="200" style="margin-top: 10px">
      <nut-cell v-for="(item,index) in list" :key="index" :show-icon="true" class="diy-cell"
                @click-cell="goMsgSet(item)">
        <div slot="title">
          <span>{{item.name}}</span>
          <span slot="desc">{{item.deviceAddressSystemSetEntity != null && item.deviceAddressSystemSetEntity.startMsg != null ? '已设置' : '未设置'}}</span>
        </div>
        <span slot="desc">{{item.deviceCount}}台</span>
      </nut-cell>
    </nut-infiniteloading>
  </div>
</template>

<script>
export default {
  name: 'StartPageMsg',
  data () {
    return {
      list: [],
      page: 1,
      limit: 10,
      isHasMore: true,
      isLoading: false,
      isErr: false,
      timer: null
    }
  },
  mounted () {
    this.user = this.$api.user
    this.onInfinite()
  },
  methods: {
    onInfinite () {
      this.isLoading = true
      this.timer = setTimeout(() => {
        this.$api.post({
          url: '/device/api/device/address/list',
          data: {
            merId: this.user.merId,
            storeId: this.user.storeId,
            page: this.page,
            limit: this.limit
          },
        }).then(res => {
          let list = res.data
          this.totalCounts = res.count
          if (this.page > 1 && list.length > 0) {
            for (let i in list) {
              this.list.push(list[i])
            }
          } else {
            this.list = list
          }
          if (this.list.length >= this.totalCounts) {
            this.isHasMore = false
          } else {
            this.page = this.page + 1
          }
        })
        this.isLoading = false
      }, 100)
    },
    goBatchSelect (type) {
      this.$router.push({
        path: '/device/BatchSelectAddress',
        query: {
          type: type
        }
      })
    },
    goMsgSet (item) {
      let data = []
      if (!this.$util.isArrOrNull(item)) {
        data.push(item)
      }
      this.$router.push({
        path: '/device/MsgSet',
        query: {
          data: encodeURIComponent(JSON.stringify(data))
        }
      })
    },
  }
}
</script>

<style scoped>
  .top-div {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: 10px 15px;
  }

  .top-div .text {
    color: #666;
  }

  .diy-cell {
    margin: 0px 15px;
    border-radius: 5px;
  }

  .diy-cell .label {
    margin-left: 5px;
    background-color: #e2e1e6;
    color: #999;
    padding: 2px 5px;
    border-radius: 2px;
  }

  >>> .nut-button {
    border-radius: 5px;
    background: #409EFF;
  }
</style>



// WEBPACK FOOTER //
// src/components/device/userInfo/accounts/StartPageMsg.vue